import ReactJS, { useEffect, useState } from "react";
import { Button } from "antd";
import { mkConfig, generateCsv, download } from "export-to-csv";

const csvConfig = mkConfig({ useKeysAsHeaders: true });

function ExportCSVButton({csvData}:any) {

const [csv, setCsv] = useState<any>();

    useEffect(()=>{

        console.log("CSV1", csvData);

        if(csvData.length > 0){

            console.log("CSV2", csvData);

            setCsv(generateCsv(csvConfig)(csvData));
            
        }

    },[csvData])

  return (
    <>
      <Button
          type="default"
          size="large"
          onClick={()=>{download(csvConfig)(csv)}}
        >
          Export to CSV
        </Button>
    </>
  );
}

export default ExportCSVButton;
